import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Page from 'flarum/common/components/Page';
import app from 'flarum/common/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import NagusiBackNav from '../common/NagusiBackNav';
import { loadApexCharts } from '../common/lazyAssetLoader';
export default class StatsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.chartsLoading = true;
    this.stats = [];
    this.charts = [];
    loadApexCharts().then(() => {
      this.chartsLoading = false;
      m.redraw();
    }).catch(err => {
      console.error('Error cargando ApexCharts:', err);
      this.chartsLoading = false;
      m.redraw();
    });
    this.loadStats();
  }
  loadStats() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/advanced-admin/stats-history'
    }).then(response => {
      this.stats = response.data || [];
      this.loading = false;

      // Set title after data loads to ensure translator is ready and title is accurate
      const pageTitle = app.translator.trans('nagusi-advanced-admin.forum.stats.title');
      app.setTitle(pageTitle);
      app.setTitleCount(0);
      m.redraw();
    });
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.destroyCharts();
  }
  destroyCharts() {
    this.charts.forEach(chart => {
      if (chart && typeof chart.destroy === 'function') {
        chart.destroy();
      }
    });
    this.charts = [];
  }
  getChartConfig(type, name, data, color, isTotal, extraOptions) {
    if (isTotal === void 0) {
      isTotal = false;
    }
    if (extraOptions === void 0) {
      extraOptions = {};
    }
    const config = {
      series: Array.isArray(name) ? name.map((n, i) => ({
        name: String(n),
        data: data[i]
      })) : [{
        name: String(name),
        data: data
      }],
      chart: {
        type: type,
        height: 400,
        zoom: {
          enabled: true
        },
        toolbar: {
          show: true
        },
        animations: {
          enabled: true
        }
      },
      colors: Array.isArray(color) ? color : [color],
      stroke: {
        curve: 'smooth',
        width: type === 'line' ? 3 : 2
      },
      fill: isTotal ? {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.5,
          opacityTo: 0.1
        }
      } : {},
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        labels: {
          formatter: val => Math.floor(val)
        }
      },
      tooltip: {
        shared: true,
        intersect: false,
        theme: 'dark'
      },
      markers: {
        size: type === 'line' ? 4 : 0,
        hover: {
          size: 6
        }
      },
      dataLabels: {
        enabled: false
      }
    };
    return _objectSpread(_objectSpread({}, config), extraOptions);
  }
  renderChart(vnode, config) {
    var _window$ApexCharts;
    if (vnode.dom.querySelector('.apexcharts-canvas')) return;
    const ApexChartsConstructor = typeof window !== 'undefined' && (((_window$ApexCharts = window.ApexCharts) == null ? void 0 : _window$ApexCharts.default) || window.ApexCharts);
    if (!ApexChartsConstructor) return;
    try {
      const chart = new ApexChartsConstructor(vnode.dom, config);
      chart.render();
      this.charts.push(chart);
    } catch (e) {
      console.error('Error rendering chart:', e);
    }
  }
  view() {
    const t = key => app.translator.trans('nagusi-advanced-admin.forum.stats.' + key).toString();
    if (this.loading || this.chartsLoading) {
      return m("div", {
        className: "StatsPage"
      }, m("div", {
        className: "Stats-Hero"
      }, m("div", {
        className: "container",
        style: "position: relative;"
      }, m(NagusiBackNav, {
        title: t('title')
      }), m("h2", null, m("i", {
        className: "fas fa-chart-line"
      }), " ", t('title')))), m("div", {
        className: "container",
        style: "text-align: center; padding: 40px;"
      }, m(LoadingIndicator, null)));
    }
    const dataPoints = this.stats.map(s => ({
      x: (window.dayjs ? window.dayjs(s.date) : new Date(s.date)).valueOf(),
      users_new: Number(s.users_new) || 0,
      users_total: Number(s.users_total) || 0,
      users_active: Number(s.users_active) || 0,
      posts_new: Number(s.posts_new) || 0,
      posts_total: Number(s.posts_total) || 0,
      discussions_new: Number(s.discussions_new) || 0,
      discussions_total: Number(s.discussions_total) || 0,
      likes_new: Number(s.likes_new) || 0,
      reactions_new: Number(s.reactions_new) || 0,
      interactions_total: (Number(s.likes_total) || 0) + (Number(s.reactions_total) || 0) + (Number(s.posts_total) || 0),
      avg_post_length: Number(s.avg_post_length) || 0,
      hot_thread: s.most_active_discussion_title || 'N/A'
    }));
    return m("div", {
      className: "StatsPage"
    }, m("div", {
      className: "Stats-Hero"
    }, m("div", {
      className: "container",
      style: "position: relative;"
    }, m(NagusiBackNav, {
      title: t('title')
    }), m("h2", null, m("i", {
      className: "fas fa-chart-line"
    }), " ", t('title')))), m("div", {
      className: "container"
    }, m("div", {
      className: "StatsPage-container"
    }, m("div", {
      className: "StatsPage-section"
    }, m("div", {
      className: "section-title"
    }, m("i", {
      className: "fas fa-users community-icon"
    }), m("h2", null, t('groups.community'))), m("div", {
      className: "charts-grid"
    }, m("div", {
      className: "chart-item"
    }, m("h3", null, t('charts.active_users')), m("p", {
      className: "chart-description"
    }, t('descriptions.active_users')), m("div", {
      className: "chart-container",
      oncreate: vnode => this.renderChart(vnode, this.getChartConfig('bar', t('labels.active_users'), dataPoints.map(d => ({
        x: d.x,
        y: d.users_active
      })), '#ef4444'))
    })), m("div", {
      className: "chart-item"
    }, m("h3", null, t('charts.new_users')), m("p", {
      className: "chart-description"
    }, t('descriptions.new_users')), m("div", {
      className: "chart-container",
      oncreate: vnode => this.renderChart(vnode, this.getChartConfig('bar', t('labels.new_users'), dataPoints.map(d => ({
        x: d.x,
        y: d.users_new
      })), '#3b82f6'))
    })), m("div", {
      className: "chart-item"
    }, m("h3", null, t('charts.total_users')), m("p", {
      className: "chart-description"
    }, t('descriptions.total_users')), m("div", {
      className: "chart-container",
      oncreate: vnode => this.renderChart(vnode, this.getChartConfig('area', t('labels.total_users'), dataPoints.map(d => ({
        x: d.x,
        y: d.users_total
      })), '#1d4ed8', true))
    })))), m("div", {
      className: "StatsPage-section"
    }, m("div", {
      className: "section-title"
    }, m("i", {
      className: "fas fa-comments content-icon"
    }), m("h2", null, t('groups.content'))), m("div", {
      className: "charts-grid"
    }, m("div", {
      className: "chart-item"
    }, m("h3", null, t('charts.daily_messages')), m("p", {
      className: "chart-description"
    }, t('descriptions.daily_messages')), m("div", {
      className: "chart-container",
      oncreate: vnode => this.renderChart(vnode, this.getChartConfig('bar', t('labels.messages'), dataPoints.map(d => ({
        x: d.x,
        y: d.posts_new
      })), '#10b981'))
    })), m("div", {
      className: "chart-item"
    }, m("h3", null, t('charts.new_discussions')), m("p", {
      className: "chart-description"
    }, t('descriptions.new_discussions')), m("div", {
      className: "chart-container",
      oncreate: vnode => this.renderChart(vnode, this.getChartConfig('bar', t('labels.new_discussions'), dataPoints.map(d => ({
        x: d.x,
        y: d.discussions_new
      })), '#6366f1'))
    })), m("div", {
      className: "chart-item"
    }, m("h3", null, t('charts.post_length')), m("p", {
      className: "chart-description"
    }, t('descriptions.post_length')), m("div", {
      className: "chart-container",
      oncreate: vnode => this.renderChart(vnode, this.getChartConfig('line', t('labels.avg_length'), dataPoints.map(d => ({
        x: d.x,
        y: d.avg_post_length
      })), '#f59e0b', false, {
        yaxis: {
          labels: {
            formatter: val => Math.floor(val) + ' car.'
          }
        }
      }))
    })))), m("div", {
      className: "StatsPage-section"
    }, m("div", {
      className: "section-title"
    }, m("i", {
      className: "fas fa-fire interactions-icon",
      style: "background: linear-gradient(135deg, #f97316, #ef4444);"
    }), m("h2", null, t('groups.trends'))), m("div", {
      className: "charts-grid"
    }, m("div", {
      className: "chart-item"
    }, m("h3", null, t('charts.interactions')), m("p", {
      className: "chart-description"
    }, t('descriptions.interactions_evolution')), m("div", {
      className: "chart-container",
      oncreate: vnode => this.renderChart(vnode, this.getChartConfig('line', [t('labels.likes'), t('labels.reactions'), t('labels.topics')], [dataPoints.map(d => ({
        x: d.x,
        y: d.likes_new
      })), dataPoints.map(d => ({
        x: d.x,
        y: d.reactions_new
      })), dataPoints.map(d => ({
        x: d.x,
        y: d.discussions_new
      }))], ['#f59e0b', '#ef4444', '#6366f1']))
    })), m("div", {
      className: "chart-item"
    }, m("h3", null, t('charts.hot_thread')), m("p", {
      className: "chart-description"
    }, t('descriptions.hot_thread')), m("div", {
      className: "chart-container",
      oncreate: vnode => this.renderChart(vnode, this.getChartConfig('bar', t('labels.thread_activity'), dataPoints.map(d => ({
        x: d.x,
        y: d.posts_new
      })), '#ef4444', false, {
        tooltip: {
          custom: function (_ref) {
            let series = _ref.series,
              seriesIndex = _ref.seriesIndex,
              dataPointIndex = _ref.dataPointIndex,
              w = _ref.w;
            const d = dataPoints[dataPointIndex];
            return '<div class="custom-tooltip">' + '<span>' + new Date(d.x).toLocaleDateString() + '</span>' + '<br/><b>' + t('labels.hot_thread_top') + '</b> ' + d.hot_thread + '</div>';
          }
        }
      }))
    })))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/stats/StatsPage', StatsPage);